import React, { Component } from 'react'
import { MediaBaseUrl, SWITCH_TO_FOREVER_PLAN } from '../../actions/api';
import { connect } from 'react-redux';
import { togglePlanSection } from '../../actions/show_modal_Action';
import { togglePlanSection_D } from '../../actions/showDisplayModalAction';
import HttpClient from '../../actions/http-client';
import { getUserInfo } from '../../actions/loginActions';
import { getProductAndPlanDetails } from '../../actions/product_details_action';
import { toast } from 'react-toastify';


class PlanExpire extends Component {
    state = {
        loading: false
    }

    upgradePlan = () => {
        this.props.pricingModal_D();
    }

    upgradeToForeverFreePlan = () => {
        const { history, getPlanDetails, userInfo } = this.props;
        this.setState({ loading: true });
        new HttpClient().post(SWITCH_TO_FOREVER_PLAN,{
            oldplan:'28',
            adminId:localStorage.getItem('adminId') ?? localStorage.getItem('ownerId'),
            type: 4
        }).then((response) => {
            const { responseCode } = response.data;
            this.setState({ loading: false });
            if (responseCode == 200) {
                userInfo(history,()=>{
                    getPlanDetails();
                    history(`/walls/home`);
                }); 
            }
        }).catch(ex => {
            this.setState({ loading: false });
            toast.error(ex?.response?.data?.responseMessage ?? "Something went wrong",{ autoClose : 3000 });
        })
    }

    render() {

        const {loading} = this.state;

        return <div className="d-flex flex-column flex-root" style={{ minHeight: 'calc(100vh - 65px)' }}>
            <div className="d-flex flex-row-fluid">
                <div className="small_container d-flex flex-row-fluid flex-column justify-content-center px-6 text-center">
                    <div className="upgrade_succ_wrap p-5 position-relative f-center">
                        <img src={`${MediaBaseUrl}success/Upgrade-Account.svg`} className="img-fluid position-relative" alt="" />
                    </div>
                    <h2 className="font-weight-boldest mb-3">{`Uh-oh! You haven’t upgraded to Social Walls Yet.`}</h2>
                    <p className="font-size-h6">It seems like you do not have a subscription to Social Walls. Therefore, you are unable to access it. </p>
                    <p className="font-size-h6">However, if you also want to use Social Walls then you can upgrade your plan from here. </p>
                    <div className="d-flex align-items-center flex-wrap justify-content-center my-10">
                        <button type="button" className="btnUpgrade btn btn-primary btn-lg btn-min-w mx-3" onClick={this.upgradePlan}>Upgrade Now!</button>
                        <button type="button" className={`popUp extendPlanBtn btn btn-outline-primary btn-lg btn-min-w mx-3 ${loading ? 'ladda-button spinner spinner-white spinner-right disabled' : ''}`} onClick={this.upgradeToForeverFreePlan}>Continue in DS Free Plan</button>
                    </div>
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        pricingModal: () => dispatch(togglePlanSection(true)),
        pricingModal_D: () => dispatch(togglePlanSection_D(true)),
        userInfo: (navigate,callback) => dispatch(getUserInfo(navigate,false,false,true,callback)),
        getPlanDetails: () => dispatch(getProductAndPlanDetails())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanExpire);